import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import MaterialChainEvent from './MaterialChainEvent';
import MaterialChainRoom from './MaterialChainRoom';
import { AlertNotice, AlertMessage, Spinner, EventDashboardDetails } from 'shared/components';
import * as materialChainActions from 'features/material-chain/duck';
import * as roomActions from 'features/room-builder/duck';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import * as staffActions from 'features/staff-and-rooms/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import { capacityDisplayLogic, isRoomOnline } from 'shared/helpers';
import {
  mapRoomMaterials,
  mapEventMaterials,
  calculateEventUsedMaterials,
  mapEventMaterialTypes,
} from 'features/material-chain/selectors';
import {
  mapRoomsByLocation,
  hasEventPaperCapacity,
  hasEventOnlineCapacity,
} from 'features/tc-event-dashboard/selectors';
import { getPersonnelRoles } from 'shared/selectors';
import { RoomTypeAndTiming, MaterialChainSubmit } from 'features/material-chain/index';
import { isEmpty, orderBy, sumBy } from 'lodash';

import './MaterialChainDashboard.scss';

const REFRESH_FREQUENCY_SEC = 30;

const filterSupervisor = (room, staff, eventId, personnelRoles) => {
  room.supervisor = staff.length
    ? staff.find(
        (pers) => pers.roomId === room.id && pers.roleName === personnelRoles.ROOM_SUPERVISOR
      )
    : {};
  return room;
};

class MaterialChainDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editTypeModalOpen: false,
      submitModalOpen: false,
      showAlertMessage: false,
      alertMessage: '',
      currentRoom: {},
      currentLocation: {},
      countSeconds: 0,
    };

    this.goToRoomRanges = this.goToRoomRanges.bind(this);
    this.closeTypeModal = this.closeTypeModal.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);
    this.toggleSubmitRanges = this.toggleSubmitRanges.bind(this);
    this.onSubmitRanges = this.onSubmitRanges.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.onInterval = this.onInterval.bind(this);
  }

  componentDidMount() {
    const eventId = this.props.match.params.eventId;
    this.intervalId = setInterval(this.onInterval, 1000);

    const { actions, tcEvent } = this.props;

    if (isEmpty(tcEvent)) {
      actions.getTcEvent(eventId).then(() => {
        const { tcEvent } = this.props;
        this.fetchData(tcEvent);
      });
    } else {
      this.fetchData();
    }

    actions.getTCEventMaterialTypes(eventId);
    actions.getEventAllMaterials(eventId);
    actions.getDevicesCheckCount(eventId);

    const alertMessage = sessionStorage.getItem('successSavedMessage');

    if (alertMessage) {
      sessionStorage.removeItem('successSavedMessage');
      this.setState({
        showAlertMessage: true,
        alertMessage: alertMessage,
      });
    }
  }

  componentDidUpdate() {
    const { eventMaterials } = this.props;
    if (!eventMaterials || !eventMaterials.length) {
      $('.actions.paper-room div.action-btn')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-placement', 'top')
        .attr('title', this.props.t('testCenter.testMaterials.tooltipAddMessage'));
      $('.actions.paper-room div.action-btn .btn').attr('disabled', true);
    } else {
      $('.actions.paper-room div.action-btn').attr('data-bs-toggle', '').attr('title', '');
      $('.actions.paper-room div.action-btn .btn').attr('disabled', false);
    }
    $('.room-status.opened')
      .attr('data-bs-toggle', 'tooltip')
      .attr('data-bs-placement', 'top')
      .attr('title', this.props.t('testCenter.testMaterials.tooltipRoomOpenedMessage'));
    $('.room-status.closed')
      .attr('data-bs-toggle', 'tooltip')
      .attr('data-bs-placement', 'top')
      .attr('title', this.props.t('testCenter.testMaterials.tooltipRoomClosedMessage'));

    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
      bootstrap.Tooltip.getOrCreateInstance(el).enable()
    );
    Array.from(
      document.querySelectorAll('.actions.paper-room div.action-btn[data-bs-toggle=""]')
    ).forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el).dispose());
  }

  goToRoomRanges(room, locationName, locationArea) {
    const eventId = this.props.match.params.eventId;

    if (!room.roomType) {
      this.setState({
        editTypeModalOpen: true,
        currentRoom: room,
        currentLocation: {
          name: locationName,
          area: locationArea,
        },
      });
      // this.props.actions.getRoomStatus(room.id);
      return;
    }

    this.props.history.push(`/test-event/${eventId}/room/${room.id}/ranges`);
  }

  closeTypeModal(redirect) {
    const eventId = this.props.match.params.eventId;
    const room = Object.assign({}, this.state.currentRoom);

    this.setState({
      editTypeModalOpen: false,
      currentRoom: {},
      currentLocation: {},
    });

    if (redirect) {
      sessionStorage.setItem(
        'successRoomTypeMessage',
        'testCenter.testMaterialsRanges.successRoomTypeAddedMessage'
      );
      this.props.history.push(`/test-event/${eventId}/room/${room.id}/ranges`);
    }
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
      alertMessage: '',
    });
  }

  toggleSubmitRanges(room) {
    this.setState((prevState) => ({
      submitModalOpen: !prevState.submitModalOpen,
      currentRoom: room || {},
    }));
  }

  fetchData(event) {
    const { actions } = this.props;
    const tcEvent = event || this.props.tcEvent;
    const eventId = this.props.match.params.eventId;

    actions.getTestCenterCycle(eventId);
    actions.getRooms(eventId);
    actions.clearTcEventStaffAction();
    actions.getTcEventStaff(eventId);
    actions.getRoomMaterialsCount(eventId);
    if (!this.props.roomTypes.length) {
      actions.getRoomTypes(eventId).then(() => {
        actions.getMaterialTypesByRoomTypes(this.props.roomTypes);
      });
    } else {
      actions.getMaterialTypesByRoomTypes(this.props.roomTypes);
    }
    actions.getCapacityTypes(tcEvent.testingEvent.adminId.cycleId.id);
  }

  async handleRefresh() {
    const { actions, tcEvent } = this.props;

    this.setState({
      loadingData: true,
    });
    const eventId = this.props.match.params.eventId;

    if (!isEmpty(tcEvent)) {
      this.fetchData();
    } else {
      actions.getTcEvent(eventId).then(() => {
        this.fetchData(this.props.tcEvent);
      });
    }

    actions.getTCEventMaterialTypes(eventId);
    actions.getEventAllMaterials(eventId);

    this.setState({
      loadingData: false,
      showAlertMessage: true,
      alertMessage: 'testCenter.roomsDashboard.successMessage',
      countSeconds: 0,
    });
  }

  onInterval() {
    this.setState((prevState) => ({
      countSeconds: prevState.countSeconds + 1,
    }));
  }

  onSubmitRanges() {
    const { roomActions, actions } = this.props;

    roomActions.submitRoomRanges(this.state.currentRoom.id).then(() => {
      if (isEmpty(this.props.errorSubmitRanges)) {
        this.setState({
          showAlertMessage: true,
          alertMessage: isRoomOnline(this.state.currentRoom.roomType)
            ? 'materialChain.successSubmitOnline'
            : 'materialChain.successSubmitRanges',
        });
        actions.getRooms(this.props.match.params.eventId);
        this.toggleSubmitRanges();
      }
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    const {
      capacityTypes,
      loading,
      locations,
      testCenterCycle,
      tcEvent,
      tcEventStaff,
      eventMaterials,
      eventUsedMaterials,
      roomMaterials,
      tcEventMaterialTypes,
      errorSubmitRanges,
      materialTypesByRoomTypes,
      devicesCheckCount,
      flagPaperEvent,
      flagOnlineEvent,
      loadingRooms,
      personnelRoles,
    } = this.props;

    const {
      submitModalOpen,
      currentRoom,
      currentLocation,
      editTypeModalOpen,
      showAlertMessage,
      alertMessage,
      loadingData,
      countSeconds,
    } = this.state;

    if (
      isEmpty(tcEvent) ||
      tcEvent.loading ||
      isEmpty(testCenterCycle) ||
      testCenterCycle.loading ||
      loading ||
      loadingRooms
    ) {
      return <Spinner />;
    }

    const nowManagedFlag = this.props.testCenterCycle.testCenterProgram.testCenter.nowManagedFlag;

    return (
      <div className={`material-chain-dashboard ${loadingData ? 'loading-data' : ''}`}>
        <div className="mb-30 title-container position-relative">
          <h4>{this.props.t('testCenter.testMaterials.title')}</h4>
          <EventDashboardDetails
            date={tcEvent.testingEvent.name}
            name={
              testCenterCycle.testCenterProgram.testCenter &&
              testCenterCycle.testCenterProgram.testCenter.name
            }
          />
        </div>

        <div className="refresh-info">
          <AlertNotice
            message={this.props.t('testCenter.roomsDashboard.infoMessage')}
            inline={true}
          />
          <div className="refresh-btn">
            <button
              className="btn btn-small btn-action"
              disabled={countSeconds < REFRESH_FREQUENCY_SEC}
              onClick={this.handleRefresh}>
              <i className="fa fa-repeat" />{' '}
              {loadingData ? (
                <span>{this.props.t('testCenter.roomsDashboard.refreshingButton')}...</span>
              ) : (
                this.props.t('testCenter.roomsDashboard.refreshButton')
              )}
            </button>
            {countSeconds < REFRESH_FREQUENCY_SEC && (
              <div className="wait-message">
                {this.props.t('testCenter.roomsDashboard.waitMessage', {
                  sec: REFRESH_FREQUENCY_SEC - countSeconds,
                })}
              </div>
            )}
          </div>
          <div>
            <i className="fa fa-repeat" />{' '}
            {this.props.t('testCenter.roomsDashboard.updatedLabel', {
              minutes: Math.floor(countSeconds / 60),
            })}{' '}
          </div>
        </div>

        {!!eventMaterials.length &&
          tcEventMaterialTypes.some(
            (type) => eventMaterials[type.id] && !eventUsedMaterials[type.id]
          ) && (
            <AlertNotice
              message={this.props.t('testCenter.testMaterials.warningMessage')}
              type="warning"
            />
          )}
        <div className="material-chain-container">
          <div className="title">
            {testCenterCycle.testCenterProgram.testCenter &&
              testCenterCycle.testCenterProgram.testCenter.name}
          </div>

          <div>{this.props.t('testCenter.testMaterials.eventInfo')}</div>
          <MaterialChainEvent
            tcEventId={tcEvent.id}
            eventMaterials={eventMaterials}
            materialTypes={tcEventMaterialTypes}
            eventUsedMaterials={eventUsedMaterials}
            devicesCheckCount={devicesCheckCount}
            displayDevicesCount={flagOnlineEvent}
            displayEventMaterials={flagPaperEvent}
            nowManagedFlag={nowManagedFlag}
          />

          {!!locations.length &&
            locations.map((location, idx) => (
              <div key={`location-${idx}`} className="mt-5">
                <div className="title">
                  {location.name}
                  {location.area && location.area.length > 0 && `, ${location.area}`} (
                  {this.props.t('roomBuilder.seatsLabel', {
                    total: sumBy(location.rooms, 'capacity'),
                  })}
                  )
                </div>
                {!nowManagedFlag && (
                  <div className="capacity-details">
                    {orderBy(capacityTypes, 'displayOrder', 'asc').map(
                      (type) =>
                        capacityDisplayLogic(location, type) && (
                          <div key={`type-${idx}-${type.id}`} className="capacity-type">
                            <span> {type.name}: </span>
                            {capacityDisplayLogic(location, type)}
                          </div>
                        )
                    )}
                  </div>
                )}
                <div>{this.props.t('testCenter.testMaterials.locationInfo')}</div>
                {location.rooms ? (
                  location.rooms.map((room, roomIdx) => (
                    <MaterialChainRoom
                      key={`location-${roomIdx}`}
                      locationName={location.name}
                      locationArea={location.area}
                      room={filterSupervisor(room, tcEventStaff, tcEvent.id, personnelRoles)}
                      tcEvent={tcEvent}
                      roomMaterials={roomMaterials[room.id]}
                      materialTypes={tcEventMaterialTypes}
                      goToRoomRanges={this.goToRoomRanges}
                      toggleSubmitRanges={this.toggleSubmitRanges}
                      materialTypesByRoomTypes={materialTypesByRoomTypes}
                      flagPaperEvent={flagPaperEvent}
                      mappedRoomTiming={this.props.mappedRoomTiming}
                    />
                  ))
                ) : (
                  <AlertNotice message={this.props.t('roomBuilder.noRooms')} />
                )}
              </div>
            ))}
        </div>
        <button className="btn btn-outline ml-0 mt-3" onClick={this.props.history.goBack}>
          {this.props.t('common.labels.back')}
        </button>
        <RoomTypeAndTiming
          room={currentRoom}
          location={currentLocation}
          modalOpen={editTypeModalOpen}
          closeModal={this.closeTypeModal}
          alertMessage="materialChain.roomTypeInfoMessage"
          editType
          cycleId={tcEvent.testingEvent.adminId.cycleId.id}
          id={this.props.match.params.eventId}
        />
        <MaterialChainSubmit
          room={currentRoom}
          tcEventMaterialTypes={tcEventMaterialTypes}
          roomMaterials={roomMaterials}
          errorSubmitRanges={errorSubmitRanges}
          submitModalOpen={submitModalOpen}
          toggleSubmitRanges={this.toggleSubmitRanges}
          onSubmitRanges={this.onSubmitRanges}
        />
        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={alertMessage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcEvent: state.tcEvent.currentEvent || {},
    locations: mapRoomsByLocation(state),
    rooms: state.tcEvent.rooms || [],
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    loading: state.materialChain.loading,
    loadingRooms: state.tcEvent.loadingRooms,
    capacityTypes: state.statics.capacityTypes,
    roomTypes: state.statics.roomTypes,
    materialTypesByRoomTypes: state.materialChain.materialTypesByRoomTypes,
    roomMaterials: mapRoomMaterials(state),
    tcEventMaterialTypes: mapEventMaterialTypes(state),
    eventMaterials: mapEventMaterials(state),
    eventUsedMaterials: calculateEventUsedMaterials(state),
    tcEventStaff: state.staff.tcEventStaff || [],
    errorSubmitRanges: state.roomOptions.errorSubmitRanges,
    roomMaterialsCount: state.materialChain.roomMaterialsCount,
    devicesCheckCount: state.tcEvent.devicesCheckCount,
    flagPaperEvent: hasEventPaperCapacity(state),
    flagOnlineEvent: hasEventOnlineCapacity(state),
    personnelRoles: getPersonnelRoles(state),
    mappedRoomTiming: state.statics.mappedRoomTiming,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...materialChainActions,
        ...tcEventActions,
        ...staffActions,
        ...staticActions,
      },
      dispatch
    ),
    roomActions: bindActionCreators(roomActions, dispatch),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(MaterialChainDashboard))
);

MaterialChainDashboard.propTypes = {
  // Props from react-router
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,

  // Props from mapStateToProps
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
    loading: PropTypes.bool,
    testingEvent: PropTypes.shape({
      name: PropTypes.string,
      adminId: PropTypes.shape({
        cycleId: PropTypes.shape({
          id: PropTypes.number,
        }),
      }),
    }),
  }),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      area: PropTypes.string,
      rooms: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          capacity: PropTypes.number,
          roomType: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  rooms: PropTypes.array,
  testCenterCycle: PropTypes.shape({
    loading: PropTypes.bool,
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        name: PropTypes.string,
        nowManagedFlag: PropTypes.bool,
      }),
    }),
  }),
  loading: PropTypes.bool,
  loadingRooms: PropTypes.bool,
  capacityTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      displayOrder: PropTypes.number,
    })
  ).isRequired,
  roomTypes: PropTypes.array.isRequired,
  materialTypesByRoomTypes: PropTypes.object.isRequired,
  roomMaterials: PropTypes.object.isRequired,
  tcEventMaterialTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ).isRequired,
  eventMaterials: PropTypes.array.isRequired,
  eventUsedMaterials: PropTypes.object.isRequired,
  tcEventStaff: PropTypes.array,
  errorSubmitRanges: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  roomMaterialsCount: PropTypes.object,
  devicesCheckCount: PropTypes.number,
  flagPaperEvent: PropTypes.bool.isRequired,
  flagOnlineEvent: PropTypes.bool.isRequired,
  personnelRoles: PropTypes.object.isRequired,
  mappedRoomTiming: PropTypes.object.isRequired,

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getTcEvent: PropTypes.func.isRequired,
    getTCEventMaterialTypes: PropTypes.func.isRequired,
    getEventAllMaterials: PropTypes.func.isRequired,
    getDevicesCheckCount: PropTypes.func.isRequired,
    getTestCenterCycle: PropTypes.func.isRequired,
    getRooms: PropTypes.func.isRequired,
    clearTcEventStaffAction: PropTypes.func.isRequired,
    getTcEventStaff: PropTypes.func.isRequired,
    getRoomMaterialsCount: PropTypes.func.isRequired,
    getRoomTypes: PropTypes.func.isRequired,
    getMaterialTypesByRoomTypes: PropTypes.func.isRequired,
    getCapacityTypes: PropTypes.func.isRequired,
  }).isRequired,
  roomActions: PropTypes.shape({
    submitRoomRanges: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
